import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import ModalImage from "react-modal-image";

// Antes este componente fazia api.get(imageUrl, { responseType: "blob" })
// pra contornar restricoes de CORS de mídia servida em outro dominio.
// Com R2 + presigned URL isso passou a quebrar:
//   1. axios envia Authorization: Bearer pro backend
//   2. backend redireciona 302 pra https://*.r2.cloudflarestorage.com/...
//   3. axios segue o redirect mantendo o header Authorization
//   4. R2 rejeita porque ele espera auth via X-Amz-Signature na URL
//
// Solucao: usar <img> direto (via react-modal-image). O navegador segue
// 302 sem mandar Authorization, e o R2 aceita. Imagens legadas em
// /public/ tambem funcionam (sao publicas no Express static).
const useStyles = makeStyles(() => ({
  messageMedia: {
    objectFit: "cover",
    width: 280,
    maxWidth: "100%",
    height: 240,
    borderRadius: 8,
    cursor: "pointer",
    backgroundColor: "rgba(0,0,0,0.04)",
  },
}));

const ModalImageCors = ({ imageUrl }) => {
  const classes = useStyles();
  if (!imageUrl) return null;
  return (
    <ModalImage
      className={classes.messageMedia}
      smallSrcSet={imageUrl}
      medium={imageUrl}
      large={imageUrl}
      alt="image"
      hideDownload={false}
      hideZoom={false}
    />
  );
};

export default ModalImageCors;
